var EmailFormOptimizedContactChannelView, SharedFooterIntlPhoneNumberView, SupportEmailFormIntlFlexibleContactChannelsView, SupportEmailFormIntlMainView, SupportV1INTLStepThreeView, SupportV1StepThreeBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormIntlMainView = require('../../email_form/INTL/main_view');

SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SupportEmailFormIntlFlexibleContactChannelsView = require('../../email_form/INTL/flexible_contact_channels');

SupportV1INTLStepThreeView = (function(superClass) {
  extend(SupportV1INTLStepThreeView, superClass);

  function SupportV1INTLStepThreeView() {
    return SupportV1INTLStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV1INTLStepThreeView.prototype.shouldShowContactChannelView = function() {
    var ref;
    return (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) || window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0)) && !window.priorityViewsEnabled();
  };

  SupportV1INTLStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormIntlMainView(options);
  };

  SupportV1INTLStepThreeView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterIntlPhoneNumberView({
          emailFormModel: _this.emailFormModel,
          renderPopup: true
        });
        return phoneNumberView.render();
      };
    })(this));
  };

  SupportV1INTLStepThreeView.prototype.configureContactChannelView = function(options) {
    if (this.isFlexibleContactEnabled()) {
      return new SupportEmailFormIntlFlexibleContactChannelsView(options);
    } else {
      return new EmailFormOptimizedContactChannelView(options);
    }
  };

  SupportV1INTLStepThreeView.prototype.renderEmailForm = function() {
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  return SupportV1INTLStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV1INTLStepThreeView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvc3RlcF90aHJlZS9JTlRML3YxX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvc3RlcF90aHJlZS9JTlRML3YxX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsNE1BQUE7RUFBQTs7O0FBQUEsNEJBQUEsR0FBK0IsT0FBQSxDQUFRLGlDQUFSOztBQUMvQiwrQkFBQSxHQUFrQyxPQUFBLENBQVEsb0VBQVI7O0FBQ2xDLDBCQUFBLEdBQTZCLE9BQUEsQ0FBUSxpQkFBUjs7QUFDN0Isb0NBQUEsR0FBdUMsT0FBQSxDQUFRLHdEQUFSOztBQUN2QywrQ0FBQSxHQUFrRCxPQUFBLENBQVEsaURBQVI7O0FBRTVDOzs7Ozs7O3VDQUVKLDRCQUFBLEdBQTZCLFNBQUE7QUFDM0IsUUFBQTtXQUFBLENBQUMsTUFBTSxDQUFDLFFBQVAsOERBQWdCLFdBQVcsQ0FBRSxvQ0FBN0IsQ0FBQSxJQUE2RCxNQUFNLENBQUMsUUFBUCx5Q0FBa0MsQ0FBRSxvQ0FBcEMsQ0FBOUQsQ0FBQSxJQUFvSSxDQUFJLE1BQU0sQ0FBQyxvQkFBUCxDQUFBO0VBRDdHOzt1Q0FHN0IsZ0JBQUEsR0FBa0IsU0FBQyxPQUFEO1dBQ2YsSUFBSSw0QkFBSixDQUFpQyxPQUFqQztFQURlOzt1Q0FHbEIscUJBQUEsR0FBdUIsU0FBQTtXQUNyQixxQ0FBQSxDQUF1QyxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUE7QUFDckMsWUFBQTtRQUFBLGVBQUEsR0FBa0IsSUFBSSwrQkFBSixDQUFvQztVQUNwRCxjQUFBLEVBQWdCLEtBQUMsQ0FBQSxjQURtQztVQUVwRCxXQUFBLEVBQWEsSUFGdUM7U0FBcEM7ZUFJbEIsZUFBZSxDQUFDLE1BQWhCLENBQUE7TUFMcUM7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQXZDO0VBRHFCOzt1Q0FTdkIsMkJBQUEsR0FBNkIsU0FBQyxPQUFEO0lBQzNCLElBQUcsSUFBQyxDQUFBLHdCQUFELENBQUEsQ0FBSDthQUNFLElBQUksK0NBQUosQ0FBb0QsT0FBcEQsRUFERjtLQUFBLE1BQUE7YUFHRSxJQUFJLG9DQUFKLENBQXlDLE9BQXpDLEVBSEY7O0VBRDJCOzt1Q0FNN0IsZUFBQSxHQUFpQixTQUFBO1dBQ2YsMEJBQTBCLENBQUEsU0FBRSxDQUFBLGVBQWUsQ0FBQyxLQUE1QyxDQUFrRCxJQUFsRCxFQUF3RCxTQUF4RDtFQURlOzs7O0dBdkJzQjs7QUEwQnpDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
